import { render, staticRenderFns } from "./TaskTracking.vue?vue&type=template&id=64c1ea98"
import script from "./TaskTracking.vue?vue&type=script&lang=js"
export * from "./TaskTracking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports